import { info } from "@randajan/simple-app/fe";

import jet from "@randajan/jet-react";

import page from "@randajan/jet-react/base/page";
import tab from "@randajan/jet-react/base/tab";
import { Locale } from "../Locale";

const _episode = ["❤️", "🤩", "😃", "🙂", "😐", "😶", "😢", "🥱", "😴", "👻", "💀"];


export const setupTitle = (Router) => {
    page.watch(_ => tab.set("title"));

    const interval = 30000;
    let step = 0;
    let state = 5;
    let int;

    const run = () => {
        clearInterval(int);
        int = setInterval(_ => tab.set("step", step++), interval);
    }


    tab.fit((next, v, f) => {
        v = Object.jet.tap(v);

        const route = Router.matchRoute(page.get("pathname")) || {};
        const routeTitle = Locale.say(route.titleId, "");
        v.title = jet.melt(["Blimp", routeTitle], " > ");

        if (f.step != v.step) {
            const stateNext = state + (v.visible ? -1 : 1);
            state = Number.jet.frame(stateNext, 0, _episode.length - 1);
            if (state !== stateNext) { clearInterval(int); }
        }

        if (v.visible != f.visible) { run(); }

        v.title += " " + _episode[state];

        return v;
    });

    run();
}


export {
    page
}
